var render = function render(){var _vm=this,_c=_vm._self._c;return _c('api-select',{ref:"reference",attrs:{"options":_vm.options,"value":_vm.value,"multiple":_vm.multiple},on:{"input":_vm.onInput},nativeOn:{"blur":function($event){return _vm.format()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }